export const NULL_STR = '-';
export const OWNER_PREFIX = 'OwnerMark___';

export type OwnershipInfo = {
	name: string;
	packageName: string | null;
	teamName: string | null;
	markerType: string;
};
export const extractOwnershipStack = (reactComponentStack: string): OwnershipInfo[] => {
	return reactComponentStack
		.split('\n')
		.flatMap((untrimmedLine) => {
			const line = untrimmedLine.trim();
			if (line.startsWith(`at ${OWNER_PREFIX}`)) {
				const withoutPrefix = line.replace(`at ${OWNER_PREFIX}`, '');
				// Exclude trailing `(source path + line number)`
				const withoutSuffix = withoutPrefix.split(' ')[0];
				return [withoutSuffix];
			}
			return [];
		})
		.flatMap((line) => {
			const parts = line.split('___');
			if (parts.length !== 4) {
				return [];
			}

			const [markerType, name, packageName, teamName] = parts;
			return [
				{
					markerType,
					name,
					packageName: packageName !== NULL_STR ? packageName : null,
					teamName: teamName !== NULL_STR ? teamName : null,
				},
			];
		});
};

export const getOwningTeam = (ownershipStack: OwnershipInfo[]): string | null => {
	return (
		ownershipStack.map(({ teamName }) => teamName).find((teamName) => teamName !== null) ?? null
	);
};

export const getContainingPackageName = (ownershipStack: OwnershipInfo[]): string | null => {
	return (
		ownershipStack
			.map(({ packageName }) => packageName)
			.find((packageName) => packageName !== null) ?? null
	);
};
